module.exports = __webpack_public_path__ + "img/file-copy-outline-rounded.d53fdad8.svg";